var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-content"},[_c('div',[_c('span',{staticClass:"big-score"},[_vm._v(_vm._s(_vm.score || 0))]),_c('span',{staticClass:"small-score"},[_vm._v(" / "+_vm._s(_vm.maxScore || 0))])]),_c('div',{staticClass:"score-title"},[_vm._v("评分")])])
}
var staticRenderFns = []

export { render, staticRenderFns }